import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  assetDomain: 'assets-human.biodigital.com',
  supportEmail: 'support@biodigital.com',
  googleAuthKey: '66261904577-061oin26uo7sor0vrqc8dnn105irq82n.apps.googleusercontent.com',
  facebookAuthKey: '218801781466301',
  googleAnalyticsId : 'UA-1141985-27',
  exportType: 'bookmark'
};
